module.exports = __webpack_public_path__ + "media/images/backgrounds/how_to/lady2-5215ff02078273ad1a596aee1037d909.svg";